import React, { useEffect } from 'react';
import { Box } from '@material-ui/core';

import CharacterGroupPicker from './CharacterGroupPicker';
import CharacterOrderPicker from './CharacterOrderPicker';
import { WdtCharacterGroup, WdtCharacterOrder } from 'types/schema-generated-types';

interface CharacterOrderAndFilterProps {
  characterGroups: WdtCharacterGroup[];
  order: WdtCharacterOrder;
  groupId?: number;
  setOrder: (order: WdtCharacterOrder) => void;
  setGroupId: (groupId?: number) => void;
}

const CharacterOrderAndFilter: React.FC<CharacterOrderAndFilterProps> = ({
  characterGroups,
  order,
  groupId,
  setOrder,
  setGroupId
}) => {
  useEffect(() => {
    setGroupId(undefined);
  }, [setGroupId, order]);

  return (
    <>
      <Box width="150px">
        <CharacterOrderPicker
          value={order}
          onChange={(event: React.ChangeEvent<HTMLInputElement>): void =>
            setOrder(event.target.value as WdtCharacterOrder)
          }
        />
      </Box>
      {characterGroups && characterGroups.length > 1 && (
        <Box width="230px">
          <CharacterGroupPicker
            groups={characterGroups}
            value={groupId}
            onChange={(event: React.ChangeEvent<HTMLInputElement>): void =>
              setGroupId(event.target.value ? parseInt(event.target.value) : undefined)
            }
          />
        </Box>
      )}
    </>
  );
};

export default CharacterOrderAndFilter;
